export default __webpack_public_path__ + "static/media/truck-and-gps.e3582d47.png";